<template>
  <div class="wrapper">
    <div class="welcome">
      <div class="container">
        <img class="welcome__logo" src="../assets/logo-white.svg" :alt="$t('Homepage.site_name')">
        <h3 class="welcome__subtitle">{{ $t("Homepage.sub_title") }}</h3>
        <SearchForm />
      </div>
    </div>
    <Footer />
  </div>

</template>

<script>
import Footer from "@/components/Footer";
import SearchForm from "@/components/Homepage/SearchForm";

export default {
  components: { SearchForm, Footer }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../assets/variables";

  .wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10000;
  }

  .welcome {
    background: rgba($brand-primary, 0.95);
    padding: 88px 0;
    text-align:center;
    color: #fff;
  }

  .welcome__logo {
    width: 328px;
    height: 57px;
    max-width: 100%;
    margin-top:20px;
  }

  .welcome__subtitle {
    font-size: 20px;
    font-weight: 400;
    margin-top:10px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Homepage.vue